
export const CHECKOUT_URL = "https://ebookpoint.shop/cart/50363936145660:1";

export const PRICE = "€24";
export const PRICE_OLD = "€80";

export const IMAGES = {
  product:
    "https://cdn.magicpatterns.com/uploads/4NgJ7cCNuuCbD4mN4se4zB/ChatGPT_Image_Jul_20__2026__07_40_25_PM-removebg-preview.png",
  clinicBg:
    "https://cdn.magicpatterns.com/patterns/generated-images/7be43b4c-d8f8-4ed6-a8bb-ab5fb4affdc9.jpg",
  bonusHome:
    "https://cdn.magicpatterns.com/patterns/generated-images/513705df-a453-44bf-8b6b-6e3d2ba5602e.jpg",
  bonusSurvey:
    "https://cdn.magicpatterns.com/patterns/generated-images/77dcaa60-fa25-4f65-bd83-5487c9b392a2.jpg",
  bonusEbooks:
    "https://cdn.magicpatterns.com/patterns/generated-images/798b1cac-9252-4bd9-9d53-87b02381b86a.jpg",
};

export function goToCheckout() {
  window.location.href = CHECKOUT_URL;
}

export function scrollToBuy() {
  const el = document.getElementById("comprar");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

/* ---------- Problemáticas ---------- */
export const PAIN_POINTS: string[] = [
  "Te quedas hasta tarde redactando informes de alta que nadie te paga.",
  "Copias los mismos datos de evaluación una y otra vez en planillas sueltas.",
  "Pierdes el control de los bonos de sesiones y regalas visitas sin darte cuenta.",
  "Improvisas los casos clínicos y las escalas de valoración sobre la marcha.",
  "El papeleo te roba el tiempo que deberías dedicar a tratar pacientes.",
];

/* ---------- Módulos desplegables ---------- */
export interface ModuleItem {
  emoji: string;
  title: string;
  count: string;
  items: string[];
}

export const MODULES: ModuleItem[] = [
  {
    emoji: "🩺",
    title: "PDFs / Checklists de consulta rápida",
    count: "13",
    items: [
      "Banderas rojas — Cervical",
      "Banderas rojas — Dorsal/Torácica",
      "Banderas rojas — Lumbar",
      "Banderas rojas — Hombro",
      "Banderas rojas — Codo/Muñeca/Mano",
      "Banderas rojas — Cadera",
      "Banderas rojas — Rodilla",
      "Banderas rojas — Tobillo/Pie",
      "Banderas rojas — Suelo pélvico",
      "Checklist maestro de banderas rojas (resumen de las 9 regiones en una sola tarjeta)",
      "Fichas técnicas de tests ortopédicos (por región)",
      "Protocolo de los primeros 10 minutos de evaluación",
      "Criterios de derivación urgente vs. prioritaria",
    ],
  },
  {
    emoji: "📝",
    title: "Plantillas Word — documentación clínica editable",
    count: "5",
    items: [
      "Bono de sesiones (con seguimiento de consumo)",
      "Consentimiento informado (genérico, adaptable por técnica)",
      "Informe de alta para médico derivante",
      "Historia clínica completa",
      "Carta de bienvenida / protocolo de primera visita",
    ],
  },
  {
    emoji: "🧮",
    title: "Excel funcionales — con fórmulas automáticas",
    count: "7",
    items: [
      "Planilla de evaluación inicial",
      "Calculadora de escalas de valoración (dolor, lumbar, miembro superior, hombro, rodilla, tobillo/pie)",
      "Seguimiento de evolución del paciente",
      "Registro de goniometría (con valores normales de referencia)",
      "Planificador de ejercicio terapéutico",
      "Checklist de alta y objetivos SMART",
      "Control de bonos y agenda de sesiones restantes",
    ],
  },
];

/* ---------- Bonos ---------- */
export interface BonusItem {
  n: number;
  title: string;
  status: "producido" | "pendiente";
}

export const BONUSES: BonusItem[] = [
  { n: 1, title: "Hoja de ejercicios domiciliarios para el paciente", status: "pendiente" },
  { n: 2, title: "Ficha de satisfacción post-alta", status: "pendiente" },
  { n: 3, title: "Plantilla de presupuesto de tratamiento", status: "pendiente" },
  { n: 4, title: "Ficha de contraindicaciones por técnica (6 técnicas)", status: "producido" },
  { n: 5, title: "Glosario de abreviaturas clínicas", status: "pendiente" },
  { n: 6, title: "Ficha de contacto de emergencia del paciente", status: "producido" },
  { n: 7, title: "Checklist RGPD para historia clínica", status: "producido" },
];

/* ---------- Testimonios largos (opiniones 5 estrellas) ---------- */
export interface Review {
  name: string;
  role: string;
  city: string;
  text: string;
}

export const REVIEWS: Review[] = [
  {
    name: "Lucía Fernández",
    role: "Fisioterapeuta",
    city: "Valencia",
    text: "Llevaba años con plantillas a medias y post-its. Con el megapack tengo la historia clínica y el alta listas en minutos. He recuperado mis tardes.",
  },
  {
    name: "Javier Moreno",
    role: "Fisio deportivo",
    city: "Sevilla",
    text: "Las banderas rojas por región son oro puro para la consulta rápida. Ya no dudo en cuándo derivar. Muy bien organizado y profesional.",
  },
  {
    name: "Marta Ruiz",
    role: "Fisioterapeuta",
    city: "Bilbao",
    text: "El control de bonos con las fórmulas de Excel me cambió la vida. Antes regalaba sesiones sin querer. Ahora todo está cuadrado.",
  },
  {
    name: "Carlos Iglesias",
    role: "Fisio de suelo pélvico",
    city: "Zaragoza",
    text: "Compré por las escalas de valoración y me quedé por todo lo demás. Los ebooks de casos clínicos son un extra que no esperaba.",
  },
];

/* ---------- Testimonios breves ---------- */
export interface ShortTestimonial {
  name: string;
  age: number;
  city: string;
  text: string;
}

export const SHORT_TESTIMONIALS: ShortTestimonial[] = [
  { name: "Ana Torres", age: 34, city: "Madrid", text: "Entrega inmediata y todo editable. Justo lo que necesitaba." },
  { name: "Diego Sánchez", age: 41, city: "Málaga", text: "Me ahorra horas de papeleo cada semana. Brutal." },
  { name: "Elena Gómez", age: 29, city: "Granada", text: "Las plantillas son súper profesionales. Mis pacientes lo notan." },
  { name: "Pablo Navarro", age: 38, city: "Murcia", text: "El pack más completo que he visto para fisios. 10/10." },
  { name: "Sara Vidal", age: 45, city: "Alicante", text: "Por fin dejo de improvisar los informes. Recomendadísimo." },
];

/* ---------- Comparativa ---------- */
export const COMPARE_WITHOUT: string[] = [
  "Horas escribiendo informes cada noche",
  "Plantillas sueltas y desordenadas",
  "Bonos de sesiones sin control",
  "Escalas calculadas a mano",
  "Improvisas cada caso clínico",
];

export const COMPARE_WITH: string[] = [
  "Informes listos en minutos",
  "25+ plantillas centralizadas",
  "Control de bonos automático",
  "Escalas con cálculo automático",
  "Protocolos y casos ya resueltos",
];

/* ---------- Objeciones ---------- */
export interface Objection {
  q: string;
  a: string;
}

export const OBJECTIONS: Objection[] = [
  {
    q: "¿Y si no sé usar Excel o Word?",
    a: "Todo viene listo para usar. Solo abres el archivo, rellenas los campos y las fórmulas hacen el resto. Si sabes escribir un WhatsApp, sabes usar el megapack.",
  },
  {
    q: "¿Sirve para mi especialidad?",
    a: "Sí. Incluye material por regiones (cervical, lumbar, hombro, rodilla, suelo pélvico…) y plantillas genéricas adaptables a cualquier técnica.",
  },
  {
    q: "¿Cómo lo recibo?",
    a: "Entrega inmediata. Al completar la compra recibes el acceso de descarga al instante en tu correo. 100% digital, en PDF, Word y Excel.",
  },
  {
    q: "¿Y si no me convence?",
    a: "El pack está pensado para que recuperes tu tiempo desde el primer día. Escríbenos a soporte y te ayudamos con lo que necesites.",
  },
];

/* ---------- Pop-up de compras ---------- */
export const SPAIN_CITIES = [
  "Madrid", "Barcelona", "Valencia", "Sevilla", "Bilbao", "Zaragoza", "Málaga",
  "Murcia", "Granada", "Alicante", "Valladolid", "Vigo", "Gijón", "A Coruña",
  "Salamanca", "Santander", "Pamplona", "San Sebastián", "Córdoba", "Toledo",
];

export const BUYER_NAMES = [
  "Lucía G.", "Javier M.", "Marta R.", "Carlos I.", "Ana T.", "Diego S.",
  "Elena G.", "Pablo N.", "Sara V.", "Andrés L.", "Nuria P.", "Iván F.",
  "Cristina B.", "Sergio D.", "Laura M.", "Rubén C.", "Patricia H.", "Álvaro R.",
];
